/* Copyright (c) 2017 Backpack Health LLC */
import * as _ from 'lodash';

import ListsService from '../../../../apiServices/ListsService';

import actionNames from '../../actionNames';
import profileActionNames from '../../../appAuthorized/redux/actionNames';

const initialState = {
  isFetching: false,
  collection: [],
  lookup: {},
  currentProfileColorThemeId: -1,
  defaultColorTheme: {
    base_color: {
      r: 216,
      g: 27,
      b: 81,
      a: 1,
    },
    highlight_color: {
      r: 255,
      g: 92,
      b: 125,
      a: 1,
    },
    accent_color: {
      r: 160,
      g: 0,
      b: 41,
      a: 1,
    },
  },
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case actionNames.lists.REQUEST_COLOR_THEME:
      return _.assign({}, state, {
        isFetching: true,
      });
    case actionNames.lists.RECEIVE_COLOR_THEME:
      return _.assign({}, {
        isFetching: false,
        defaultColorTheme: action.payload.collection[0],
      }, action.payload);
    case actionNames.lists.RECEIVE_ALL:
    case actionNames.lists.REQUEST_ALL:
      return _.assign({}, state, action.payload.colorTheme);
    case profileActionNames.setCurrentColorTheme:
      return _.assign({}, state, {
        currentProfileColorThemeId: action.payload,
      });
    default:
      return state;
  }
}

export function receiveColorThemeList(payload) {
  return {
    type: actionNames.lists.RECEIVE_COLOR_THEME,
    payload,
  };
}

export function requestColorThemeList() {
  return (dispatch) => {
    dispatch({
      type: actionNames.lists.REQUEST_COLOR_THEME,
      payload: {},
    });

    ListsService.colorTheme((apiError, responseCollection) => {
      const lookup = {};
      let collection = [];

      if (!apiError) {
        collection = responseCollection;
        for (let i = 0; i < responseCollection.length; i++) {
          lookup[collection[i].id] = collection[i];
        }
      }

      dispatch(receiveColorThemeList({
        collection,
        lookup,
      }));
    });
  };
}

export const selectors = {
  getColorTheme: (colorThemeId, state) => {
    return state.lists.colorTheme.lookup[colorThemeId] || {};
  },

  getCurrentColorTheme: (state) => {
    const colorThemeId = state.lists.colorTheme.currentProfileColorThemeId;
    const foundColor = state.lists.colorTheme.collection.filter((c) => c.id === colorThemeId);
    return foundColor.length > 0 ? foundColor[0] : state.lists.colorTheme.defaultColorTheme;
  },

  getColorThemes: (state) => {
    return state.lists.colorTheme.collection;
  },

  // getCurrentColorTheme: (state) => state.lists.colorTheme.defaultColorTheme,
};
